export { saveReadingPaneOptionQuick } from './actions/saveReadingPaneOption';
